<template>
  <b-modal id="ModalEmail">
    <Header
      mini
      titulo="E-MAILS PARA MONITORAMENTO"
      icone="envelope"
      cor="azul"
      slot="modal-header"
    />
    <div>
      <h3>
        EM QUAL E-MAIL VOCÊ GOSTARIA DE RECEBER AS INFORMAÇÕES DO MONITORAMENTO?
      </h3>
      <div
        v-for="(email, index) in selectedEmails"
        @click="emailChange(email, index)"
        :key="email.id"
      >
        <p-radio
          :checked="selectedEmails[index].selected"
          class="p-switch"
          :name="`switchEmail-${index}`"
          color="primary"
        >
          {{ blUsuarioPro ? "usuario_pro@email.com.br" : email.email }}
        </p-radio>
      </div>
    </div>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Cancelar"
        icone="times"
        :click="cancelar"
      />
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Confirmar"
        icone="check"
        :click="salvarEmail"
        cor="azul"
      />
    </template>
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";
import Api from "@/services/api.js";
import Log from "@/services/log.js";
import { mapGetters } from "vuex";

export default {
  name: "ModalEmail",
  components: {
    BotaoPadrao,
    Header
  },
  inject: ["pushAlert"],
  data() {
    return {
      selectEmail: "",
      selectedEmails: [],
      blLoadingButton: false
    };
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
    if (!this.blUsuarioPro) {
      new Api().get("Usuario/listarEmails").then(response => {
        this.selectEmail = response.dados.email_cadastrado;

        // Emails Selecionados
        var emailsSelecionados = [];

        if (this.selectEmail) {
          if (this.selectEmail.indexOf(";") > -1) {
            emailsSelecionados = this.selectEmail.split(";");
          } else {
            emailsSelecionados.push(this.selectEmail);
          }
        }

        emailsSelecionados = emailsSelecionados.map(email => {
          return email.toLowerCase();
        });

        this.selectedEmails = [];
        const dadosEmails = Object.values(response.dados.email);

        // Emails Unicos
        var emailsUnicos = [];

        dadosEmails.map(dado => {
          const emailCheck = dado.toLowerCase();
          const exist = emailsUnicos.find(email => {
            return email === emailCheck;
          });

          if (!exist) {
            emailsUnicos.push(emailCheck);
          }
        });

        this.selectedEmails = emailsUnicos.map((e, i) => {
          var exist = emailsSelecionados.find(emailSelect => {
            return emailSelect === emailsUnicos[i];
          });

          return {
            id: i,
            email: emailsUnicos[i],
            selected: exist ? true : false
          };
        });
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },
  computed: {
    ...mapGetters("auth", {
      blUsuarioPro: "getUsuarioPro"
    })
  },
  methods: {
    salvarEmail() {
      this.blLoadingButton = true;
      let obj = {};
      new Api()
        .post("Usuario/salvarEmailUsuarioConfig", {
          email: this.selectEmail
        })
        .then(response => {
          this.pushAlert("E-mail salvo com sucesso!", "success");

          obj = {
            strUrl: "Usuario/salvarEmailUsuarioConfig",
            intIdItem: null,
            strMetodoHttp: "POST",
            intIdFerramenta: 3,
            intIdTipoAcao: 3,
            strTipoAcao: "Editar",
            strObjetoClick: "Salvar E-mail Monitoramento",
            strDestinoClick: ""
          };
          this.registraLogAcesso(obj);
          this.blLoadingButton = false;
          this.$root.$emit("bv::hide::modal", "ModalEmail");
        });
    },
    registraLogAcesso: function(obj) {
      let assinatura;
      let nome_usuario;

      let testAssinatura = localStorage.getItem("assinatura");
      if (
        testAssinatura &&
        testAssinatura !== undefined &&
        testAssinatura !== "undefined" &&
        testAssinatura != null
      ) {
        assinatura = JSON.parse(localStorage.getItem("assinatura"));
      }

      if (localStorage.getItem("nome_usuario")) {
        nome_usuario = localStorage.getItem("nome_usuario");
      }

      let objFinal = {
        intIdUsuario: assinatura.id_usuario,
        strNomeUsuario: nome_usuario,
        strIP: assinatura.ip,
        strUrl: obj.strUrl,
        strMetodoHttp: obj.strMetodoHttp,
        intIdItem: obj.intIdItem,
        intIdFerramenta: obj.intIdFerramenta,
        strObjetoClick: obj.strObjetoClick,
        strDestinoClick: obj.strDestinoClick,
        intIdTipoAcao: obj.intIdTipoAcao,
        strTipoAcao: obj.strTipoAcao
      };

      new Log().reportAcesso(objFinal);
    },
    handleKey(event) {
      let modal = document.getElementById("ModalEmail");
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          this.$root.$emit("bv::hide::modal", "ModalEmail");
        }
      }
    },
    handleClick() {
      this.$root.$emit("bv::hide::modal", "ModalEmail");
    },
    cancelar() {
      this.$root.$emit("bv::hide::modal", "ModalEmail");
    },
    emailChange: function(event, index) {
      const selected = this.selectedEmails[index].selected;

      this.selectedEmails[index].selected = !selected;

      var emails = [];

      this.selectedEmails.map(e => {
        if (e.selected) {
          emails.push(e.email.toLowerCase());
        }
      });

      this.selectEmail = emails.join(";");
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-family: "Open Sans";
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ea2a7;
}
</style>
